import React, { useEffect } from 'react'
import { CategoryTeaser, CategoryTeaserButton } from '../components/CategoryTeaser'
import { useSelector } from 'react-redux'
import { AppState } from '../store'
import { hideOtherPageElements, showOtherPageElements } from '../util'

export const Overview: React.FC = () => {
  const categories = useSelector((p: AppState) => p.categoriesReducer.categories)

  useEffect(() => {
    showOtherPageElements()

    return () => {
      hideOtherPageElements(true)
    }
  })

  return (
    <div className="grid-outer-container">
      <div className="grid-row grid-gap4-below grid-mobile-gap2-below">
        {Object.entries(categories).map(([title, category]) => {
          const categoryWithImage = category.find((c) => c.categoryImage !== null)

          const dictionaryValue =
            category[0].categoryId.indexOf('e-series') > -1
              ? window.translations['Material - See e-Series robots']
              : category[0].categoryId.indexOf('cb-series') > -1
              ? window.translations['Material - See CB-Series robots']
              : window.translations['Material - See OEM Control Box']

          return (
            <div key={title} className="grid-span4 grid-omega3 grid-tablet-span12 grid-tablet-omega1">
              <CategoryTeaser
                backgroundImage={categoryWithImage === undefined ? '' : categoryWithImage.categoryImage!}
                title={title}
                bullets={category.map((c) => c.categoryTag)}
                button={
                  <CategoryTeaserButton
                    to={`/${categoryWithImage!.categoryId}`}
                    dangerouslySetInnerHTML={{
                      __html: dictionaryValue.replace(/(e)-(series)/i, '<span class="helper-nocase">$1</span>-$2')
                    }}
                  />
                }
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
